<script>
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { EventBus } from '../event-bus.js'
import RegionHeader from '../component/region-header/RegionHeader.vue'
import RegionNavigation from '../component/region-navigation/RegionNavigation.vue'

export default {
  name: "PageHeader",
  components: {
    RegionHeader,
    RegionNavigation,
  },
  setup(){
    const store = useStore();
    const isAccountOpen = ref(false);

    const classes = computed(() => {
      return ["page-header", {
        "open-account": isAccountOpen.value,
        "open-navigation": store.state.navigation.main
      }];
    });

    function toggleAccountMenu() {
      isAccountOpen.value = !isAccountOpen.value;
      if (store.state.navigation.main) {
        store.state.navigation.main = false;
      }
    }

    function toggleNavMenu() {
      if (isAccountOpen.value) {
        isAccountOpen.value = false;
      }
    }

    onMounted(() => {
      EventBus.$on("toggleAccountMenu", toggleAccountMenu);
      EventBus.$on("toggleNavMenu", toggleNavMenu);
    });

    return  { classes }
  }
}
</script>

<style lang="sass">
@import '../common/styles/settings'
@import 'PageHeader'
</style>
